export const OperatorId = {
  NTK: 81,
  OneTouchTravel: 230,
  RussianExpress: 98,
  SunMar: 48,
  MyAgent: [226, 299], //travelata
  Travelata: [226, 299],
  TezTour: 50,
  AnexTour: 5,
  AleanTour: 122,
  BiblioGlobus: 11,
  Paks: 92,
  ICS: 26,
  FunSun: 55,
  SpaceTravel: 46,
  LetsFly: 300,
  Loti: 264,
  ChinaTravel: 13,
  CoralTravel: 117,
  Panteon: 121,
  Yandex: 301,
};
